module.exports = __webpack_public_path__ + "img/change2.124b9506.svg";